import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';

function HowItWorks({ onClose }) {
  const [activeTab, setActiveTab] = useState('client'); // 'client' | 'executor' | 'escrow'

  return (
    <div className="min-h-screen bg-[#090d16] text-white p-6 md:p-12 flex flex-col items-center relative font-sans">
      
      <Helmet>
        <title>Как это работает — Гарантия Escrow и арбитраж | RealWork.pro</title>
        <meta name="description" content="Узнайте, как безопасно заказывать работы и зарабатывать в USDT на бирже RealWork.pro. Гарантия Escrow, единая комиссия 7% и честный арбитраж." />
      </Helmet>

      {/* Кнопка закрытия/возврата (если открывается как модалка или отдельная страница) */}
      {onClose && (
        <button 
          onClick={onClose}
          className="absolute top-6 right-6 bg-slate-800 hover:bg-slate-700 text-gray-300 font-bold py-2 px-4 rounded-xl text-xs transition cursor-pointer border border-slate-700 flex items-center gap-2"
        >
          ✕ Закрыть
        </button>
      )}

      {/* ШАПКА СТРАНИЦЫ */}
      <div className="max-w-4xl w-full text-center mt-4 mb-10">
        <div className="inline-flex items-center gap-2 px-3 me-2 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-xs font-bold uppercase tracking-wider mb-4">
          🛡️ Прозрачные правила и безопасность
        </div>
        <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight mb-4">
          Как работает <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400">RealWork.pro</span>
        </h1>
        <p className="text-gray-400 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
          Простая пошаговая система безопасных сделок в USDT. Мы берем единую комиссию 7% и защищаем средства обеих сторон от обмана и недобросовестности.
        </p>
      </div>

      {/* ПЕРЕКЛЮЧАТЕЛЬ РОЛЕЙ (ТАБЫ) */}
      <div className="flex bg-[#111827] p-1.5 rounded-2xl border border-gray-800 mb-12 max-w-md w-full shadow-lg">
        <button
          onClick={() => setActiveTab('client')}
          className={`flex-1 py-2.5 rounded-xl text-xs font-bold transition duration-200 cursor-pointer ${
            activeTab === 'client' 
              ? 'bg-indigo-600 text-white shadow-md shadow-indigo-600/30' 
              : 'text-gray-400 hover:text-white'
          }`}
        >
          💼 Заказчикам
        </button>
        <button
          onClick={() => setActiveTab('executor')}
          className={`flex-1 py-2.5 rounded-xl text-xs font-bold transition duration-200 cursor-pointer ${
            activeTab === 'executor' 
              ? 'bg-indigo-600 text-white shadow-md shadow-indigo-600/30' 
              : 'text-gray-400 hover:text-white'
          }`}
        >
          🛠 Исполнителям
        </button>
        <button
          onClick={() => setActiveTab('escrow')}
          className={`flex-1 py-2.5 rounded-xl text-xs font-bold transition duration-200 cursor-pointer ${
            activeTab === 'escrow' 
              ? 'bg-indigo-600 text-white shadow-md shadow-indigo-600/30' 
              : 'text-gray-400 hover:text-white'
          }`}
        >
          ⚖️ Escrow & Спор
        </button>
      </div>

      {/* СОДЕРЖИМОЕ ТАБОВ */}
      <div className="max-w-4xl w-full">
        
        {/* ТАБ 1: ЗАКАЗЧИКАМ */}
        {activeTab === 'client' && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 animate-in fade-in duration-300">
            <div className="bg-[#111827]/70 p-6 rounded-2xl border border-gray-800/80 backdrop-blur-md relative overflow-hidden">
              <span className="text-4xl font-black text-indigo-500/20 absolute top-4 right-4">01</span>
              <div className="w-10 h-10 rounded-xl bg-indigo-500/10 text-indigo-400 border border-indigo-500/20 flex items-center justify-center font-bold mb-4">
                📝
              </div>
              <h3 className="font-bold text-lg text-white mb-2">Публикация задания</h3>
              <p className="text-gray-400 text-xs leading-relaxed">
                Опишите суть задачи, прикрепите файлы, укажите дедлайн и стоимость в USDT. Публикация бесплатна и занимает меньше минуты.
              </p>
            </div>

            <div className="bg-[#111827]/70 p-6 rounded-2xl border border-gray-800/80 backdrop-blur-md relative overflow-hidden">
              <span className="text-4xl font-black text-indigo-500/20 absolute top-4 right-4">02</span>
              <div className="w-10 h-10 rounded-xl bg-purple-500/10 text-purple-400 border border-purple-500/20 flex items-center justify-center font-bold mb-4">
                🔒
              </div>
              <h3 className="font-bold text-lg text-white mb-2">Заморозка средств (Escrow)</h3>
              <p className="text-gray-400 text-xs leading-relaxed">
                Умнея система выберет лучшего исполнителя. Деньги списываются с баланса, но не уходят фрилансеру, а блокируются системой в качестве гарантии.
              </p>
            </div>

            <div className="bg-[#111827]/70 p-6 rounded-2xl border border-gray-800/80 backdrop-blur-md relative overflow-hidden">
              <span className="text-4xl font-black text-indigo-500/20 absolute top-4 right-4">03</span>
              <div className="w-10 h-10 rounded-xl bg-amber-500/10 text-amber-400 border border-amber-500/20 flex items-center justify-center font-bold mb-4">
                🔎
              </div>
              <h3 className="font-bold text-lg text-white mb-2">Проверка отчета</h3>
              <p className="text-gray-400 text-xs leading-relaxed">
                Исполнитель сдает работу в специальной форме (текст, ссылки, скриншоты). Вы внимательно проверяете результат. Если есть недочеты — отправляете на доработку.
              </p>
            </div>

            <div className="bg-[#111827]/70 p-6 rounded-2xl border border-gray-800/80 backdrop-blur-md relative overflow-hidden">
              <span className="text-4xl font-black text-indigo-500/20 absolute top-4 right-4">04</span>
              <div className="w-10 h-10 rounded-xl bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 flex items-center justify-center font-bold mb-4">
                🎉
              </div>
              <h3 className="font-bold text-lg text-white mb-2">Приемка и закрытие</h3>
              <p className="text-gray-400 text-xs leading-relaxed">
                Нажимаете «Принять работу» — Escrow разблокирует оплату и переведет ее исполнителю. Заказ успешно завершен!
              </p>
            </div>
          </div>
        )}

        {/* ТАБ 2: ИСПОЛНИТЕЛЯМ */}
        {activeTab === 'executor' && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 animate-in fade-in duration-300">
            <div className="bg-[#111827]/70 p-6 rounded-2xl border border-gray-800/80 backdrop-blur-md relative overflow-hidden">
              <span className="text-4xl font-black text-indigo-500/20 absolute top-4 right-4">01</span>
              <div className="w-10 h-10 rounded-xl bg-indigo-500/10 text-indigo-400 border border-indigo-500/20 flex items-center justify-center font-bold mb-4">
                🎯
              </div>
              <h3 className="font-bold text-lg text-white mb-2">Поиск заказа и отклик</h3>
              <p className="text-gray-400 text-xs leading-relaxed">
                Выбираете подходящую задачу в каталоге (микро-задачи, нейросети, копирайтинг, разработка) и откликаетесь на нее.
              </p>
            </div>

            <div className="bg-[#111827]/70 p-6 rounded-2xl border border-gray-800/80 backdrop-blur-md relative overflow-hidden">
              <span className="text-4xl font-black text-indigo-500/20 absolute top-4 right-4">02</span>
              <div className="w-10 h-10 rounded-xl bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 flex items-center justify-center font-bold mb-4">
                🛡️
              </div>
              <h3 className="font-bold text-lg text-white mb-2">Гарантированный старт</h3>
              <p className="text-gray-400 text-xs leading-relaxed">
                После того как заказчик выберет вас, бюджет задачи замораживается в Escrow. Вы получаете уведосление — теперь выполняться безопасно!
              </p>
            </div>

            <div className="bg-[#111827]/70 p-6 rounded-2xl border border-gray-800/80 backdrop-blur-md relative overflow-hidden">
              <span className="text-4xl font-black text-indigo-500/20 absolute top-4 right-4">03</span>
              <div className="w-10 h-10 rounded-xl bg-purple-500/10 text-purple-400 border border-purple-500/20 flex items-center justify-center font-bold mb-4">
                📤
              </div>
              <h3 className="font-bold text-lg text-white mb-2">Сдача отчета в срок</h3>
              <p className="text-gray-400 text-xs leading-relaxed">
                Выполняете ТЗ и прикрепляете отчет (ссылки, готовый результат, скриншоты подтверждения) прямо в карточке заказа.
              </p>
            </div>

            <div className="bg-[#111827]/70 p-6 rounded-2xl border border-gray-800/80 backdrop-blur-md relative overflow-hidden">
              <span className="text-4xl font-black text-indigo-500/20 absolute top-4 right-4">04</span>
              <div className="w-10 h-10 rounded-xl bg-pink-500/10 text-pink-400 border border-pink-500/20 flex items-center justify-center font-bold mb-4">
                💰
              </div>
              <h3 className="font-bold text-lg text-white mb-2">Получение USDT</h3>
              <p className="text-gray-400 text-xs leading-relaxed">
                Заказчик принимает работу (или происходит автоприемка через 36 часов), и вы сразу получаете расчет в USDT за вычетом фиксированных 7% комиссии. Эти средства уходят на оплату сервера, маркетинг и дальнейшую разработку.
              </p>
            </div>
          </div>
        )}

        {/* ТАБ 3: ESCROW И АРБИТРАЖ */}
        {activeTab === 'escrow' && (
          <div className="space-y-6 animate-in fade-in duration-300">
            <div className="bg-[#111827]/70 p-8 rounded-2xl border border-gray-800/80 backdrop-blur-md">
              <h3 className="font-bold text-xl text-white mb-4 flex items-center gap-2">
                <span>🛡️</span> Как устроена защита Escrow?
              </h3>
              <p className="text-gray-300 text-sm leading-relaxed mb-4">
                Escrow — это финансовый гарант, встроенный в платформу RealWork.pro. Заказчик не может просто так отменить оплату, если работа сделана качественна, а исполнитель не может получить деньги, не сдав результат.
              </p>
              <div className="p-4 rounded-xl bg-indigo-500/10 border border-indigo-500/20 text-xs text-indigo-300 leading-relaxed">
                ⏱️ **Автоприемка:** Если исполнитель отправил отчет, а заказчик не выходит на связь и не нажимает «Принять» в течение 72 часов, система автоматически завершает сделку и выплачивает деньги исполнителю.
              </div>
            </div>

            <div className="bg-[#111827]/70 p-8 rounded-2xl border border-gray-800/80 backdrop-blur-md">
              <h3 className="font-bold text-xl text-white mb-4 flex items-center gap-2">
                <span>⚖️</span> Разрешение споров и Арбитраж
              </h3>
              <p className="text-gray-300 text-sm leading-relaxed mb-4">
                Если между заказчиком и исполнителем возникнет разногласие (например, работа сделана не по ТЗ или заказчик требует то, чего не было в первоначальном описании), любая сторона может открыть Спор.
              </p>
              
              <ul className="space-y-3 text-xs text-gray-400 border-t border-gray-800 pt-4">
                <li className="flex items-start gap-2">
                  <span className="text-indigo-400 font-bold">•</span>
                  <span>Арбитр платформы подключится к заказу и изучит исходное ТЗ, переписку и сданные файлы.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-indigo-400 font-bold">•</span>
                  <span>Если исполнитель сорвал сроки или не выполнил ключевые пункты ТЗ — <strong>100% средств возвращаются на баланс заказчика</strong>.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-indigo-400 font-bold">•</span>
                  <span>Если исполнитель полностью выполнил ТЗ, а заказчик предъявляет новые требования вне условий — <strong>средства выплачиваются исполнителю</strong>.</span>
                </li>
              </ul>
            </div>
          </div>
        )}

      </div>

      {/* ФУТЕР С ССЫЛКОЙ НА РЕГИСТРАЦИЮ */}
      <div className="mt-16 text-center">
        <p className="text-gray-400 text-xs mb-4">Готовы к честной и безопасной работе?</p>
        <button 
          onClick={onClose}
          className="py-3 px-8 rounded-xl bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-sm transition duration-200 shadow-lg shadow-indigo-600/30 cursor-pointer"
        >
          Перейти к регистрации / Входу
        </button>
      </div>

    </div>
  );
}

export default HowItWorks;